import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);
const API = process.env.REACT_APP_API_URL || '/api';

// Set default axios base
axios.defaults.baseURL = API;

export function AuthProvider({ children }) {
  const [user, setUser]         = useState(null);
  const [membership, setMembership] = useState(null);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ftf_token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchMe();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchMe = async () => {
    try {
      const res = await axios.get('/auth/me');
      setUser(res.data.user);
      setMembership(res.data.membership);
    } catch {
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const res = await axios.post('/auth/login', { email, password });
    const { token, user } = res.data;
    localStorage.setItem('ftf_token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(user);
    await fetchMe();
    return user;
  };

  const register = async (data) => {
    const res = await axios.post('/auth/register', data);
    const { token, user } = res.data;
    localStorage.setItem('ftf_token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem('ftf_token');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    setMembership(null);
  };

  return (
    <AuthContext.Provider value={{ user, membership, loading, login, register, logout, fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
